import { Controller } from '@hotwired/stimulus';

/**
 * Enables/disables a submit button based on whether the input value matches an expected string.
 * Used for destructive confirmation modals (e.g., archive organization).
 *
 * Usage:
 *   <div data-controller="confirmation-input">
 *     <input data-confirmation-input-target="input"
 *            data-confirmation-input-expected-value="TRIPODE"
 *            data-action="input->confirmation-input#validate" />
 *     <button data-confirmation-input-target="submit" disabled>Archiver</button>
 *   </div>
 */
export default class extends Controller {
  static targets = ['input', 'submit'];
  static values = { expected: String };

  connect() {
    // Read expected value from the input's data attribute if not on the controller
    if (!this.expectedValue && this.hasInputTarget) {
      this.expectedValue = this.inputTarget.dataset.confirmationInputExpectedValue || '';
    }
  }

  validate() {
    const matches = this.inputTarget.value.trim() === this.expectedValue;
    this.submitTarget.disabled = !matches;
  }
}
